export default __webpack_public_path__ + "static/media/Galleria-Master-Plan-Active.99b15af0.png";